var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-image',{class:[_vm.$style.section, _vm.$style[_vm.size], _vm.isRect && _vm.$style.rect],attrs:{"src":_vm.src,"srcset":_vm.srcset},on:{"error":function($event){return _vm.$emit('error')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }